import { ArrowRight, Leaf, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export const Offers = () => (
  <section id="accompagnement" data-testid="offers-section" className="bg-cream py-20 sm:py-28">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">
          Accompagnement
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Vous choisissez votre niveau d'accompagnement.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-10">
        <Reveal>
          <article
            data-testid="offer-support"
            className="flex h-full flex-col rounded-3xl border border-[#E8E5DF] bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-md sm:p-12"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sage/15 text-sage">
              <Leaf className="h-5 w-5" />
            </span>
            <h3 className="mt-7 text-xs font-bold uppercase tracking-[0.25em] text-navy">
              Essentiel
            </h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-stone-500 sm:text-base">
              Pour les clients qui souhaitent rester acteurs de leur projet tout
              en bénéficiant de conseils et d'un accompagnement à distance.
            </p>
            <Link
              data-testid="offer-support-cta"
              to="/tarifs"
              className="group mt-8 flex w-fit items-center gap-2 rounded-full border border-navy px-7 py-3.5 text-sm font-bold text-navy transition-colors duration-300 hover:bg-navy hover:text-white"
            >
              Découvrir Essentiel
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </article>
        </Reveal>

        <Reveal delay={0.1}>
          <article
            data-testid="offer-expertise"
            className="flex h-full flex-col rounded-3xl bg-navy p-8 text-white shadow-lg shadow-navy/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl sm:p-12"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-cognac-light">
              <ShieldCheck className="h-5 w-5" />
            </span>
            <h3 className="mt-7 text-xs font-bold uppercase tracking-[0.25em] text-cognac-light">
              Pack complet
            </h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-white/70 sm:text-base">
              Pour les clients qui souhaitent déléguer davantage le pilotage et
              bénéficier d'un accompagnement renforcé pendant les travaux.
            </p>
            <Link
              data-testid="offer-expertise-cta"
              to="/tarifs"
              className="group mt-8 flex w-fit items-center gap-2 rounded-full bg-cream px-7 py-3.5 text-sm font-bold text-navy transition-colors duration-300 hover:bg-cognac hover:text-white"
            >
              Découvrir le Pack complet
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </article>
        </Reveal>
      </div>
    </div>
  </section>
);
